import { useContext } from 'react';
import { RealtimeContext } from 'contexts/realtime_context';

const useRealtime = () => {
    return useContext(RealtimeContext);
};

export default useRealtime;
